import { inject, Injectable } from '@angular/core';
import { ActionTypeLabel } from '@fullyops/data/action-types/entities/action-type-entity';
import { ApiAssetTypesAdapterService } from '@fullyops/data/asset-types/api-adapter.service';
import {
  AssetType,
  AssetTypeInput,
  ListedAssetType,
} from '@fullyops/data/asset-types/asset-type';
import { createStore } from '@ngneat/elf';
import {
  deleteAllEntities,
  selectAllEntities,
  setEntities,
  withEntities,
} from '@ngneat/elf-entities';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AssetTypesService {
  private api = inject(ApiAssetTypesAdapterService);

  private store = createStore(
    { name: 'asset-types' },
    withEntities<ListedAssetType>({ idKey: 'id' }),
  );

  types$ = this.store.pipe(selectAllEntities());

  refresh(): void {
    this.api.getAll().subscribe((res) => this.store.update(setEntities(res)));
  }

  refreshByActionType(at: ActionTypeLabel): void {
    this.api
      .getAllByActionType(at)
      .subscribe((res) => this.store.update(setEntities(res)));
  }

  create(input: AssetTypeInput): Observable<{ id: string }> {
    return this.api.create(input);
  }

  getById(id: string): Observable<AssetType> {
    return this.api.getById(id);
  }

  update(id: string, input: AssetTypeInput): Observable<void> {
    return this.api.update(id, input);
  }

  delete(id: string): Observable<void> {
    return this.api.delete(id);
  }

  clear(): void {
    this.store.update(deleteAllEntities());
  }
}
